import { createAppAsyncThunk, getReceiptItemAvailableQuantity } from '@/warehouse/helpers';
import { closeSnackbar, enqueueSnackbar } from 'notistack';
import { TrackableStatus } from '@/shared/models';
import { useItemWorkflowTableStore } from '@/warehouse/components/ItemWorkflowTable/business';
import { workflowItemProcessedSnackbarDuration } from '@/warehouse/constants';
import { playWarehouseSound } from '@/warehouse/hooks';
import { getConfirmFieldsFromReceiptItem } from '@/warehouse/modules/crossdockReceipt/helpers';
import { crossdockReceiptActions } from '../crossdockReceipt.state';
import { confirmReceiptItem } from './confirmReceiptItem';
const tryApproveReceiptItem = createAppAsyncThunk('receipt/tryApproveReceiptItem', async (receiptItem, { dispatch }) => {
    if (!receiptItem) {
        const { searchTerm, setSearchTerm } = useItemWorkflowTableStore.getState();
        if (searchTerm.trim().length === 0)
            return;
        // A single snackbar is allowed at one moment. Manually closing the existed one.
        closeSnackbar();
        playWarehouseSound('error');
        enqueueSnackbar({
            key: searchTerm,
            preventDuplicate: true,
            variant: 'receiptSubmissionError',
            article: searchTerm,
            anchorOrigin: { vertical: 'top', horizontal: 'center' },
            autoHideDuration: workflowItemProcessedSnackbarDuration,
        });
        setSearchTerm('');
        return;
    }
    const availableQuantity = getReceiptItemAvailableQuantity(receiptItem);
    if (availableQuantity < 1) {
        playWarehouseSound('full');
        return;
    }
    if (receiptItem.trackableStatus === TrackableStatus.Confirmed) {
        dispatch(crossdockReceiptActions.openAcceptTrackableReceiptItemDialog({ trackableReceiptItem: receiptItem }));
        return;
    }
    const receiptItemConfirm = getConfirmFieldsFromReceiptItem(receiptItem);
    if (availableQuantity === 1) {
        const confirmItem = {
            ...receiptItemConfirm,
            quantity: 1,
        };
        dispatch(confirmReceiptItem(confirmItem));
        return;
    }
    dispatch(crossdockReceiptActions.openApproveReceiptItemDialog({ receiptItemConfirm, availableQuantity }));
});
export { tryApproveReceiptItem };
